"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordFieldWithLabel = exports.PasswordField = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var PasswordField = (function (_super) {
    __extends(PasswordField, _super);
    function PasswordField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showPassword: false
        };
        return _this;
    }
    PasswordField.prototype.render = function () {
        var _this = this;
        var showPassword = this.state.showPassword;
        var props = this.props;
        return (React.createElement(core_1.InputGroup, __assign({ id: props.id, readOnly: props.readOnly, leftIcon: "lock", type: showPassword ? 'text' : 'password', intent: props.error ?
                core_1.Intent.DANGER :
                showPassword ?
                    core_1.Intent.WARNING :
                    core_1.Intent.NONE, value: props.value, placeholder: props.placeholder, fill: true }, props.large ? { large: true } : {}, { onChange: function (e) { return props.onChange(e.target.value); }, rightElement: React.createElement(core_1.Button, { intent: showPassword ? core_1.Intent.WARNING : core_1.Intent.NONE, minimal: true, icon: showPassword ? 'eye-off' : 'eye-on', onClick: function () { return _this.setState({ showPassword: !showPassword }); } }) })));
    };
    return PasswordField;
}(React.Component));
exports.PasswordField = PasswordField;
var PasswordFieldWithLabel = function (props) { return (React.createElement(core_1.FormGroup, { intent: props.error ? core_1.Intent.DANGER : core_1.Intent.NONE, inline: props.inline, label: React.createElement("span", { className: "b" }, props.label), helperText: props.error ? props.error : props.helperText, labelFor: props.id },
    React.createElement(PasswordField, __assign({}, props)))); };
exports.PasswordFieldWithLabel = PasswordFieldWithLabel;
//# sourceMappingURL=PasswordField.js.map